<template>
  <view class="container">
    <view class="news">
      <view class="news-item">
        新闻中心
      </view>
    </view>
  </view>
</template>
